module.exports = __webpack_public_path__ + "static/img/calgary3.958c39e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/calgary3.jpg
// module id = 80
// module chunks = 9